import { render, staticRenderFns } from "./CategoryTable.vue?vue&type=template&id=c85a467e&scoped=true&"
import script from "./CategoryTable.vue?vue&type=script&lang=js&"
export * from "./CategoryTable.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTable.vue?vue&type=style&index=0&id=c85a467e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85a467e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/bikrampahi/Projects/upwork/5 Brian/sndle.io/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VFlex,VIcon,VLayout})
